import { apiRequest } from './client';
import type {
  DailySalesSummaryResponse,
  ReceiptDetailResponse,
  ReceiptFilters,
  ReceiptListResponse,
  ReceiptSummaryResponse,
} from '../types/receipts';

const RECEIPTS_PATH = '/api/integrations/loyverse/receipts';

export function getReceipts(filters: ReceiptFilters): Promise<ReceiptListResponse> {
  return apiRequest<ReceiptListResponse>(`${RECEIPTS_PATH}?${toQuery(filters)}`);
}

export function getReceipt(receiptId: string): Promise<ReceiptDetailResponse> {
  return apiRequest<ReceiptDetailResponse>(`${RECEIPTS_PATH}/${receiptId}`);
}

export function getReceiptSummary(
  filters: Pick<ReceiptFilters, 'dateFrom' | 'dateTo' | 'storeExternalId'>,
): Promise<ReceiptSummaryResponse> {
  const summaryFilters = {
    dateFrom: filters.dateFrom,
    dateTo: filters.dateTo,
    ...(filters.storeExternalId
      ? { storeExternalId: filters.storeExternalId }
      : {}),
  };

  return apiRequest<ReceiptSummaryResponse>(
    `${RECEIPTS_PATH}/summary/basic?${toQuery(summaryFilters)}`,
  );
}

export function getDailySalesSummary(
  filters: Pick<ReceiptFilters, 'dateFrom' | 'dateTo' | 'storeExternalId'>,
): Promise<DailySalesSummaryResponse> {
  const summaryFilters = {
    dateFrom: filters.dateFrom,
    dateTo: filters.dateTo,
    ...(filters.storeExternalId
      ? { storeExternalId: filters.storeExternalId }
      : {}),
  };

  return apiRequest<DailySalesSummaryResponse>(
    `${RECEIPTS_PATH}/summary/daily?${toQuery(summaryFilters)}`,
  );
}

function toQuery(filters: Partial<ReceiptFilters>): string {
  const query = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== '') query.set(key, String(value));
  });
  return query.toString();
}
